export function getViewportSize() {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
//# sourceMappingURL=viewport.js.map